import { api } from '../auth/apiClient';

export async function getProfilePhoto() {
    return api.get('/user/profile-photo');
}

export async function uploadProfilePhoto(imageDataUrl) {
    return api.post('/user/profile-photo', { imageDataUrl });
}

export async function removeProfilePhoto() {
    return api.delete('/user/profile-photo');
}
